import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as utils from '../../../../utils/OrderUtils';
import styles from './AccommodationDetails.module.scss';
import '../../../../translations/i18n';

function AccommodationDetails(props) {
  const {
    tabID, details, transport, isParisPackage, isVilla,
  } = props;
  const [roomsAdded, setRoomsAdded] = useState(false);
  useEffect(() => {
    if (Object.keys(details.rooms).length > 0) {
      setRoomsAdded(true);
    }
  }, [details]);

  const { t } = useTranslation('common');

  const renderConfirmationNumbers = () => {
    if (!details?.supplierConfirmationNumber?.length) {
      return 'Pending';
    }

    if (details.supplierConfirmationNumber.length === 1) {
      return details.supplierConfirmationNumber[0];
    }

    return details.supplierConfirmationNumber.map((entry, index) => (
      <p key={entry} className={styles.confirmationItem}>
        Room
        {' '}
        {index + 1}
        :
        {' '}
        <b>
          {entry}
        </b>
      </p>
    ));
  };

  return (
    <>
      <h2 className={styles.title}>{isVilla ? t('tickets.villa_details') : t('tickets.hotel_details')}</h2>
      <div className={styles.accommodation}>
        <div className={styles.image}>
          <img alt="" src={details.img} />
        </div>
        <div className={styles.info}>
          <div className={styles.infoHeader}>
            <div>
              <h3 className={styles.accommodationName}>{details.title}</h3>
              <h4 className={styles.accommodationSubtitle}>
                {details.rooms[0][0].orderTicketId.title}
              </h4>
            </div>
            <h4 className={styles.bookingStatus}>{details.bookingStatus}</h4>
          </div>
          <div className={styles.details}>
            <div className={styles.detailsChunk}>
              <ul className={styles.checkInOut}>
                <li className={styles.checkInOutItem}>
                  <em>
                    {t('tickets.checkin')}
                    :
                    {' '}
                  </em>
                  <strong>{utils.formatDate(details.checkin)}</strong>
                </li>
                <li className={styles.checkInOutItem}>
                  <em>
                    {t('tickets.checkout')}
                    :
                    {' '}
                  </em>
                  <strong>{utils.formatDate(details.checkout)}</strong>
                </li>
                <li className={styles.checkInOutItem}>
                  <em>
                    {t('tickets.accommodation_confirm')}
                    :
                    {' '}
                  </em>
                  <span className={styles.supplierConfirmationNumber}>
                    {renderConfirmationNumbers()}
                  </span>
                </li>
              </ul>
            </div>
            <div className={styles.priceIncludes}>
              {details.ticketDaysDuration > 0 ? (
                <p className={styles.includesHeading}>
                  {t('tickets.price_includes')}
                  {transport.tickets.inbound && t('tickets.eurostar1')}
                  {roomsAdded && t('tickets.accommodation')}
                  {details.tickets && isParisPackage && t('tickets.tickets')}
                </p>
              ) : null}

              <ul className={styles.includes}>
                {transport.tickets.inbound && (
                  <li className={`${styles.includesItem} ${styles.eurostar}`}>
                    <svg>
                      <use xlinkHref="#eurostar" />
                    </svg>
                    <strong>{t('tickets.eurostar')}</strong>
                  </li>
                )}
                {roomsAdded && details.duration > 0 && (
                  <li className={`${styles.includesItem} ${styles.nights}`}>
                    <svg>
                      <use xlinkHref="#bed" />
                    </svg>
                    <strong>
                      {details.duration}
                      {' '}
                      {t('tickets.nights')}
                    </strong>
                  </li>
                )}
                {details.ticketDaysDuration > 0 && isParisPackage && (
                  <li className={`${styles.includesItem} ${styles.daysParks}`}>
                    <svg>
                      <use xlinkHref="#tickets" />
                    </svg>
                    <strong>
                      <span>
                        {details.ticketDaysDuration}
                        {' '}
                        {t('tickets.days')}
                        {' '}
                      </span>
                      <span>
                        2
                        {t('tickets.parks')}
                        {' '}

                      </span>
                    </strong>
                  </li>
                )}
              </ul>
              <ul className={styles.address}>
                {details.accommodationAddress && details.accommodationAddress.length > 0 && (
                  <>
                    {details.accommodationAddress.name.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.name}
                      </li>
                    )}
                    {details.accommodationAddress.street1.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.street1}
                      </li>
                    )}
                    {details.accommodationAddress.city.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.city}
                      </li>
                    )}
                    {details.accommodationAddress.region.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.region}
                      </li>
                    )}
                    {details.accommodationAddress.postcode.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.postcode}
                      </li>
                    )}
                    {details.accommodationAddress.country.length > 0 && (
                      <li className={styles.addressItem}>
                        {details.accommodationAddress.country}
                      </li>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccommodationDetails;
